<template>
  <component :is="render()"></component>
</template>

<script lang="tsx" setup>
import { PropType } from 'vue';
import { NStep, NSteps } from 'naive-ui';

import { ContentsParse, FeatureNoticeResp } from '@/api/login';

const props = defineProps({
  popupContents: {
    type: Array as PropType<FeatureNoticeResp[] | undefined>,
    default: () => [],
  },
});

const noticeTitle = (contentVal: FeatureNoticeResp) => {
  return (
    <div class="notice-title">
      {contentVal.noticeTitle} {Boolean(contentVal.noticeDate) && ` (${contentVal.noticeDate})`}
    </div>
  );
};

const noticeContent = (contentVal: FeatureNoticeResp) => {
  if (!contentVal.content) return null;
  try {
    const contentJson = JSON.parse(contentVal.content) as ContentsParse[];

    return (
      <>
        {contentJson?.length && (
          <div>
            {contentJson.map((ctx, idx) => (
              <>
                <div class="module-name" key={`${ctx.moduleName}-${idx}`}>
                  {ctx.moduleName}
                </div>
                <ul class="list">
                  {ctx?.moduleContext.map((item, index) => (
                    <li class="list-item" key={`${item}-${index}`}>
                      {item}
                    </li>
                  ))}
                </ul>
              </>
            ))}
          </div>
        )}
      </>
    );
  } catch (err) {
    return <div class="list">{contentVal.content}</div>;
  }
};

const render = () => {
  const slots = {
    icon: () => <div class="slot-icon" />,
  };
  return (
    <div class="inside-content">
      <NSteps vertical>
        {props.popupContents?.map((item, index) => (
          <NStep
            key={`${item.noticeDate}-${index}`}
            title={noticeTitle(item) as any}
            description={noticeContent(item) as any}
            v-slots={slots}
          />
        ))}
      </NSteps>
    </div>
  );
};
</script>

<style lang="scss" scoped>
.inside-content {
  width: 100%;
  max-height: 380px;
  overflow: auto;

  @media screen and (max-height: 730px) {
    max-height: 480px;
  }

  .notice-title {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .module-name {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .list {
    margin-left: 16px;
    overflow: auto;
    font-size: 14px;
    &-item {
      width: 90%;
      margin-bottom: 4px;
      display: flex;
      line-height: 24px;
      &::before {
        margin-top: 10px;
        margin-right: 16px;
        content: '';
        display: block;
        height: 6px;
        width: 6px;
        min-width: 6px;
        background-color: #572df3;
        border-radius: 50%;
      }
    }
  }

  .slot-icon {
    height: 18px;
    width: 18px;
    background-color: #572df3;
    border-radius: 50%;
  }
}
</style>

<style lang="scss">
.inside-content {
  .n-steps.n-steps--vertical:not(.n-steps--show-description) > .n-step {
    padding-bottom: 4px;
    margin-bottom: 2px;
  }

  .n-step-indicator {
    box-shadow: none;
  }

  .n-step-indicator-slot {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
